import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export const Breadcrumbs = ({
  className,
  note
}) => {
  if (!className || !note) return null;
  return <div className="flex items-center text-sm text-gray-500 mb-2" data-id="element-5">
      <span data-id="element-6">Classes</span>
      <ChevronRightIcon size={16} className="mx-1" data-id="element-7" />
      <span data-id="element-8">{className}</span>
      <ChevronRightIcon size={16} className="mx-1" data-id="element-9" />
      <span className="text-gray-700" data-id="element-10">{note}</span>
    </div>;
};